import {useDispatch, useSelector, useStore} from 'react-redux';
import {deepClone} from 'fast-json-patch';
import {ElementInteraction} from '../incase-domain/proptypes/runfile';
import {savePresentationRunFileAction} from '../store/actions/runfile.actions';
import {loadedPresentationSelector} from '../store/selectors/presentation.selectors';
import {AppState} from '../store/reducer';

export function useSaveRunfile(): typeof savePresentationRunFile {
    const dispatch = useDispatch();
    const presentation = useSelector(loadedPresentationSelector);
    const store = useStore<AppState>();

    function savePresentationRunFile(
        elementRunFile: ElementInteraction,
        elementId: string,
        slideId: string,
        newPoints: number | undefined
    ): void {
        const {runFile} = store.getState().runFileReducer;
        const newElementInteractions: Record<string, Record<string, ElementInteraction>> = deepClone({...runFile.elementInteractions});

        if (!newElementInteractions[slideId]) {
            newElementInteractions[slideId] = {};
        }

        newElementInteractions[slideId][elementId] = elementRunFile;

        let newRunFile;

        if ((newPoints || newPoints === 0) && presentation?.gameConfig.isGamificationOn) {
            newRunFile = {
                ...runFile,
                points: newPoints,
                elementInteractions: newElementInteractions,
            };
        } else {
            newRunFile = {
                ...runFile,
                elementInteractions: newElementInteractions,
            };
        }

        dispatch(savePresentationRunFileAction(newRunFile));
    }

    return savePresentationRunFile;
}
